export const toCamelCase = (str) => {
  const sanitizedStr = str.replace(/[^a-zA-Z0-9]+(.)?/g, (match, chr) => chr ? chr.toUpperCase() : '').trim()

  return sanitizedStr.charAt(0).toLowerCase() + sanitizedStr.slice(1)
}

export const toPascalCase = (str) => {
  if (!str) {
    return ''
  }

  return str.replace(/^\w|[A-Z]|\b\w/g, (word) => word.toUpperCase()).replace(/\s+/g, '')
}

export const descriptionToPath = (description) => {
  if (!description) {
    return '/unknown-path'
  }

  return '/' + description.trim().toLowerCase().replace(/\s+/g, '-').replace(/_/g, '-')
}

export const groupAndMergeReadModels = (rawReadModels, allEntities) => {
  const grouped = {}

  rawReadModels.forEach((rm) => {
    const key = `${rm.entityId || rm.associatedEntity.id}-${rm.cardinality}`
    if (!grouped[key]) {
      grouped[key] = []
    }
    grouped[key].push(rm)
  })

  return Object.values(grouped).map((group) => {
    const baseModel = group[0]
    const allIds = group.map((rm) => rm.id).sort()
    const entityId = baseModel.entityId || baseModel.associatedEntity.id
    const entity = allEntities.find((e) => e.id === entityId)

    if (!entity) {
      return { ...baseModel, allIds, allDescriptions: group.map((rm) => rm.description) }
    }

    const fieldsMap = {}
    group.forEach((rm) => {
      (rm.fields || []).forEach((field) => {
        const existingField = fieldsMap[field.name]
        if (!existingField || (field.type === 'filter' && existingField.type !== 'filter')) {
          fieldsMap[field.name] = field
        }
      })
    })
    const allFields = Object.values(fieldsMap)

    return {
      ...baseModel,
      id: allIds.length > 0 ? allIds[0] : baseModel.id,
      description: baseModel.cardinality === 'one-to-many' ? `Get All ${entity.name}s` : `Get ${entity.name} by ID`,
      entityId,
      fields: allFields,
      allIds,
      allDescriptions: group.map((rm) => rm.description),
      associatedEntity: entity
    }
  })
}
